import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../contexts/ApiClientContext'

export interface UseProjectConfigOptions {
  enabled?: boolean
}

export function useProjectConfig({ 
  enabled = true 
}: UseProjectConfigOptions = {}) {
  const apiClient = useApiClient()
  
  return useQuery({
    queryKey: ['project', apiClient.getProjectId()],
    queryFn: async () => {
      const response = await apiClient.getProject()
      return response.project
    },
    enabled: enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  })
} 